import * as React from 'react';
import { IProgramWithPaymentCalculation } from '../../../../types/mortgage';
import { ProgramItem } from './components';
import * as styles from './MortgageProgramCarousel.css';
import { VerticalScrollable } from '../../../VerticalScrollable';
import { useDeviceType } from '@cian/ui-kit';
import { ContentContainer } from '../../../ContentContainer';

interface IMortgageProgramCarouselProps {
  items: IProgramWithPaymentCalculation[];
  onProgramSelect(program: IProgramWithPaymentCalculation): void;
}

export const MortgageProgramCarousel: React.FC<IMortgageProgramCarouselProps> = ({ items, onProgramSelect }) => {
  const deviceType = useDeviceType();

  if (!items.length) {
    return null;
  }

  const isPhone = deviceType === 'phone';

  const carousel = (
    <VerticalScrollable className={styles['carousel']} dataName="MortgageProgramCarousel" withScrollPadding={isPhone}>
      {items.map(item => (
        <ProgramItem key={item.id} {...item} onClick={() => onProgramSelect(item)} />
      ))}
    </VerticalScrollable>
  );

  return isPhone ? carousel : <ContentContainer>{carousel}</ContentContainer>;
};
